import * as fetch from 'isomorphic-fetch';
import { ActionType } from './index';
import { ISearchFacet } from '../objects/iSearchFacet';

export function loadResults() {
	return {
		type: ActionType.REQUEST_RESULTS
	};
}

export function didLoadResults(json) {
	return {
		type: ActionType.RECEIVE_RESULTS,
		searchResultData: json
	};
}

export function didLoadResultsError() {
	return { type: ActionType.RECEIVE_RESULTS, response: {} };
}

export function fetchResults() {
	return function (dispatch, getState) {
		dispatch(loadResults());
        let state = getState();
        let search = JSON.stringify(state.searchFacets, (key, value) => {
			if ((key == 'Text' || key == 'Value') && value != null)
				return encodeURIComponent(value);
			else
				return value;
		}); 
		return fetch(`/api/catalogSearch/search?
				sEcho=1&
				iColumns=1&
				sColumns=&
				iDisplayStart=${state.displayStart}&
				iDisplayLength=${state.displayLength}&
				mDataProp_0=&
				sSearch_0=&
				bRegex_0=false&
				bSearchable_0=true&
				bSortable_0=true&
				sSearch=${search}&
				bRegex=false&
				iSortCol_0=0&
				sSortDir_0=asc&
				iSortingCols=1&
				DefaultCatalogNode=${state.defaultCatalogNode}&
				_=1497895052601
			`, { credentials: 'include' })
			.then(response => response.json())
			.then(json =>
				dispatch(didLoadResults(json)))
			.catch((e) => { console.log(e); dispatch(didLoadResultsError()); });
	}
}

export function changeResultsLength(newDisplayLength: number, newDisplayStart: number) {
	return { type: ActionType.CHANGE_LENGTH, newDisplayLength: newDisplayLength, newDisplayStart: newDisplayStart };
}

export function prevPage() {
	return { type: ActionType.PREVIOUS_PAGE }
}

export function nextPage() {
	return { type: ActionType.NEXT_PAGE }
}

export function jumpToPage(page: number) {
	return { type: ActionType.JUMP_TO_PAGE, page: page };
}

export function initializeKeyword(initialValue: Array<{ Text: string, Value: string }>) {
	return { type: ActionType.INIT_KEYWORD, name: 'Keyword', search: initialValue }
}

export function updateKeyword(initialValue: Array<{ Text: string, Value: string }>) {
	return { type: ActionType.UPDATE_KEYWORD, name: 'Keyword', search: initialValue }
}

export function initializeFacet(name: string, value: Array<{ Text: string, Value: string }>) {
	return { type: ActionType.INIT_FACET, name: name, search: value }
}

export function updateFacet(name: string, value: Array<{ Text: string, Value: string }>) {
	return { type: ActionType.UPDATE_FACET, name: name, search: value }
}

export function loadStateFromStorage(persistedState: any) {
	return { type: ActionType.LOAD_STATE_FROM_STORAGE, persistedState: persistedState }
}